import { TASK_FIELDS_TO_SNAKECASE } from '@components/CRM/Tasks/constants';
import { VIEWS } from '@constants/tasks';
import { createAction } from '@reduxjs/toolkit';
import { ValueOf } from '@utils/tsUtils';
import { ISearchRelationEntitiesActionPayload } from '../types/tasks';

const CREATE_TASK = 'CREATE_TASK';
const SELECT_TASK = 'SELECT_TASK';
const UPDATE_TASK = 'UPDATE_TASK';
const UPDATE_TASK_IN_LIST = 'UPDATE_TASK_IN_LIST';
const UPLOAD_TASK_ATTACHMENTS = 'UPLOAD_TASK_ATTACHMENTS';
const DELETE_TASK_ATTACHMENT = 'DELETE_TASK_ATTACHMENT';

const FETCH_TASKS = 'FETCH_TASKS';
const FETCH_TASK_LOGS = 'FETCH_TASK_LOGS';
const FETCH_TASK_COMMENTS = 'FETCH_TASK_COMMENTS';
const SEND_TASK_COMMENT = 'SEND_TASK_COMMENT';
const SET_TASKS_PAGE = 'SET_TASKS_PAGE';
const CHANGE_VIEW = 'CHANGE_VIEW';

const CREATE_TASK_RELATION = 'CREATE_TASK_RELATION';
const REMOVE_TASK_RELATION = 'REMOVE_TASK_RELATION';
const SEARCH_RELATION_ENTITIES = 'SEARCH_RELATION_ENTITIES';

export const WS_UPDATE_ACTIVE_TASK = 'WS_UPDATE_ACTIVE_TASK';
export const WS_UPDATE_TASK_IN_LIST = 'WS_UPDATE_TASK_IN_LIST';
export const WS_ADD_TASK_IN_LIST = 'WS_ADD_TASK_IN_LIST';
export const WS_ADD_TASK_LOG_IN_LIST = 'WS_ADD_TASK_LOG_IN_LIST';
export const WS_ADD_TASK_COMMENT_IN_LIST = 'WS_ADD_TASK_COMMENT_IN_LIST';
export const WS_DELETE_TASK_FROM_LIST = 'WS_DELETE_TASK_FROM_LIST';

// TODO: типизировать
export const createTaskAction = createAction<any>(CREATE_TASK);
export const uploadTaskAttachmentsAction = createAction<{
  attachments: FileList;
}>(UPLOAD_TASK_ATTACHMENTS);
export const deleteTaskAttachmentAction = createAction<{
  deletedAttachment: number;
}>(DELETE_TASK_ATTACHMENT);
export const updateTaskAction =
  createAction<ValueOf<typeof TASK_FIELDS_TO_SNAKECASE>>(UPDATE_TASK);
export const updateTaskInListAction =
  createAction<ValueOf<typeof TASK_FIELDS_TO_SNAKECASE>>(UPDATE_TASK_IN_LIST);
export const selectTaskAction = createAction<{ id: string }>(SELECT_TASK);
export const changeViewAction = createAction<{ view: ValueOf<typeof VIEWS> }>(
  CHANGE_VIEW
);

export const fetchTasksAction = createAction(FETCH_TASKS);
export const fetchTaskLogsAction = createAction(FETCH_TASK_LOGS);
export const fetchTaskCommentsAction = createAction(FETCH_TASK_COMMENTS);
export const sendTaskCommentAction = createAction<any>(SEND_TASK_COMMENT);
export const setTasksPageAction = createAction(SET_TASKS_PAGE);

export const wsUpdateActiveTaskAction = createAction(WS_UPDATE_ACTIVE_TASK);

export const createTaskRelationAction = createAction<any>(CREATE_TASK_RELATION);
export const removeTaskRelationAction = createAction<any>(REMOVE_TASK_RELATION);

export const searchRelationEntitiesAction =
  createAction<ISearchRelationEntitiesActionPayload>(SEARCH_RELATION_ENTITIES);
